
import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import vmwareService from "services/admin/masters/vmwareService";
import Select from 'react-select';
import MaterialTable from 'material-table';
import { toast } from "react-toastify";
import { getMatrixId } from "utils/matriceHelpers";
import {
  MSG_CREATE_RECORD,
  MSG_UPDATE_RECORD,
  MSG_COMBINE_KEY_WARNING,
  MSG_MAPPING_DELETE_WARNING,
  MSG_MAPPING_RESTORE_WARNING
} from "constants/admin/masters/vmware";
import {
  ERROR_MESSAGE_UNKNOWN,
  MSG_RECORD_DELETE,
  MSG_RECORD_UNDO_DELETE,
} from "constants/common";
function ManageVmwareCPLD() {
  const [breadcrumbs, setBreadCrumbs] = useState([
    { title: "UCP VMware Masters Mapping", url: "/admin/master/ucp-vmware/" },
    { title: "Manage Mapping" },
  ]);

  const serviceObj = new vmwareService();
  const [combineKeyDetails, setCombinekeyDetails] = useState([]);
  const [selectedCombineKeys, setCombineKeys] = useState([]);
  const [cpldValue, setCpldValue] = useState("");
  const [cpldTableData, setCpldTableData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isEditForm, setEditForm] = useState(false);
  const [editableItem, setEditableItem] = useState(null);
  const [showDeleteConfirmBox, setDeleteConfirmBoxFunction] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null)
  const [warningType, setWarningType] = useState(null);
  const Id = getMatrixId(window.location.pathname);


  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    serviceObj.getAllInitialData(Id)
      .then((response) => {
        let combineKeyList = response?.vmware_combine_keys_list;
        let list = combineKeyList.map((item) => {
          return {
            id: item.id,
            value: item.combine_key,
            label: item.combine_key,
          }
        });
        setCombinekeyDetails(list);
        setCpldTableData(response?.vmware_cpld_mapping_list)
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      })
  }
  // multi select dropdown function
  const selectMultipleValue = (selectedValues) => {
    setCombineKeys(selectedValues);
  }
  const resetForm = () => {
    setCombineKeys([]);
    setCpldValue("");
    setErrorMessage("");
    setEditForm(false);
    setEditableItem(null);
    selectedCombineKeys([]);
    setWarningType("")
  }
  const addCPLDMapping = (e) => {
    e.preventDefault()
    let selectedKeys = selectedCombineKeys.map(key => key.id);
    // check validation
    if (cpldValue === "" || selectedKeys.length === 0) {
      let message = "";
      if (cpldValue === "" && selectedKeys.length === 0) {
        message = MSG_COMBINE_KEY_WARNING;
      }
      else if (cpldValue === "") {
        message = "Please enter CPLD name!"
      } else if (selectedKeys.length === 0) {
        message = MSG_COMBINE_KEY_WARNING
      }
      setErrorMessage(message);
    }
    // call POST api 
    else {
      let data = {
        cpld: cpldValue,
        vmware_combine_keys: selectedKeys
      }
      serviceObj.createCPLDMapping(data).then((response) => {
        toast.success(MSG_CREATE_RECORD);
        getData();
        resetForm();
        setErrorMessage("")
      })
    }
  }
  //edit form
  const editForm = (data) => {
    setEditForm(true);
    // call get api to get edit cpld details.
    serviceObj.getCPLDKeyDetails(data.id).then((response) => {
      // storing editable item details in local state for final edit api
      setEditableItem(response)
      let cpldValue = response?.record_details?.cpld;
      let combineKeys = response?.vmware_combine_keys.map((item) => {
        return {
          id: item.id,
          value: item.combine_key,
          label: item.combine_key,
        }
      })
      // set edit form values
      setCpldValue(cpldValue);
      setCombineKeys(combineKeys)
    });

  }
  //update CPLD
  const updateCPLDMapping = (e) => {
    e.preventDefault();
    let data = {
      cpld: cpldValue,
      vmware_combine_keys: selectedCombineKeys.map((item => item.id))
    };
    let ID = editableItem.record_details.id;
    serviceObj.updateCPLDMapping(ID, data).then((response) => {
      toast.success(MSG_UPDATE_RECORD);
      getData();
      resetForm();
    }).catch((error) => toast.error(ERROR_MESSAGE_UNKNOWN))


  }
  //delete CPLD
  const deleteCPLDFunction = () => {
    let ID = itemToBeDeleted.id;
    serviceObj.deleteCPLDMapping(ID)
      .then((response) => {
        let toastMessage = warningType === "restore" ? MSG_RECORD_UNDO_DELETE : MSG_RECORD_DELETE;
        toast.success(toastMessage);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getData();
        setItemToBeDeleted(null);
      }).catch((error) => {
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getData();
        setItemToBeDeleted(null);
      })

  }

  // show warning confirmation popup
  const showWarning = (rowData) => {
    let type = rowData.is_deleted ? "restore" : "delete";
    setWarningType(type);
    let message = rowData.is_deleted ? MSG_MAPPING_RESTORE_WARNING : MSG_MAPPING_DELETE_WARNING;
    setConfirmMessage(message + rowData.cpld + " ?");
    setDeleteConfirmBoxFunction(true);
    setItemToBeDeleted(rowData);
  };
  const cancelDeleteItem = () => {
    setDeleteConfirmBoxFunction(false);
    setItemToBeDeleted(null);
  }
  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breadcrumbs} disableEditTitle={true} />
      {showDeleteConfirmBox ? (
        <ConfirmBox
          actionHandler={deleteCPLDFunction}
          handleSubmit={deleteCPLDFunction}
          cancelDeleteItem={cancelDeleteItem}
        >
          {confirmMessage}
        </ConfirmBox>
      ) : null}
      <div className="form-group d-flex">
        <div className="col-sm-6">
          <form>
            <div className="row pl-2 pb-1">

              <div className="col-sm-11">
                <label htmlFor={""} className="mr-sm-2 mt-2"><b>VMware Combine Key</b></label>
                {/* add multi select dropdown */}
                <Select
                  isMulti
                  name="Combine Key"
                  options={combineKeyDetails}
                  classNamePrefix="select"
                  onChange={(e) => selectMultipleValue(e)}
                  value={selectedCombineKeys}


                />
                <label htmlFor={"VMware CPLD"} className="mr-sm-2 mt-2"><b> CPLD</b></label>
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    maxLength="60"
                    name="cpld"
                    value={cpldValue}
                    onChange={(e) => setCpldValue(e.target.value)}
                    disabled={isEditForm}
                    placeholder="Enter CPLD Name"
                  />


                </div>
              </div>
            </div>
            {errorMessage !== "" && <div className='col-sm-10 mb-2'>


              <div class="text-danger">{errorMessage}</div>

            </div>
            }
            <div className="col-sm-12">
              <button type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2"><i className="fa fa-refresh"></i> Reset</button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                // disabled={isSubmitting}
                onClick={isEditForm ? updateCPLDMapping : addCPLDMapping}
              >
                {isEditForm ? "Update" : "Add"}
                {/* {isSubmitting?"Please wait...": isEditableForm?"Update":"Add"}  */}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-6">
          <MaterialTable
            title="CPLD Mappings"
            columns={[
              { title: "Combine Key", field: 'vmware_combine_key' },
              { title: 'CPLD', field: 'cpld' }
            ]}

            data={cpldTableData}

            options={{
              headerStyle: {
                backgroundColor: '#e9ecef',
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400

            }}

            localization={{
              header: {
                actions: 'Actions',
              },
            }}
            actions={[

              (rowData) => ({
                icon: "edit",
                tooltip: !rowData.is_deleted && "Edit Record",
                onClick: (e, data) => {
                  // call edit function
                  editForm(data)
                },
                hidden: !rowData?.id || rowData.is_deleted

              }),
              (rowData) => ({
                icon: rowData.is_deleted ? "undo" : "delete",
                tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                onClick: (e, data) => {
                  showWarning(data)
                },
                hidden: !rowData?.id // display action only if any valid item is present
              })
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default ManageVmwareCPLD;